import styled from 'styled-components';
import { colors } from '../../../theme/styled';

export const VideoContainer = styled.video`
  background-color: ${colors.secondary};
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
